<template>
  <div class="block">
    <div class="block-title">快手小程序-团购券</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="快手商品券同步" name="synchronous">
        <Ks-coupon-synchronous ref="synchronousRef" />
      </el-tab-pane>
      <el-tab-pane label="团购券使用情况" name="usage">
        <ks-coupon-group :activeName="activeName" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import KsCouponGroup from "./KsCouponGroup";
import KsCouponSynchronous from "./KsCouponSynchronous.vue";
export default {
  components: {
    KsCouponGroup,
    KsCouponSynchronous
  },
  data() {
    return {
      activeName: "synchronous",
      agentName: "",
    };
  },
  mounted() {

  },
  methods: {
    handleClick(tab, event) {
      this.activeName = tab.name;
      if(tab.name === 'synchronous'){
        this.$refs.synchronousRef.reset();
      }
      console.log(tab.name, event, "ee");
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponGroup/index.vue